<template>
  <detail
    :on-manager="onManager"
    :data="data"
    :isEditDesc="true"
    :isEditName="false"
    :base-info="baseInfo"
    :hiddenKeys="hiddenKeys" />
</template>

<script>
import {
  getSubscriptionProjectTableColumn,
  getFrequencyTableColumn,
  getSubjectTableColumn,
  getEmailsTableColumn,
  getRoleTableColumn,
  getDataScopeTableColumn,
  getNotifyTypeTableColumn,
} from '../utils/columns'

export default {
  name: 'ReportDomainSubscriptionListDetail',
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      hiddenKeys: ['status', 'project_domain', 'tenant'],
      baseInfo: [
        getSubscriptionProjectTableColumn(),
        getFrequencyTableColumn(),
        getSubjectTableColumn(),
        getEmailsTableColumn({ scope: this.$store.getters.scope }),
        getRoleTableColumn({ scope: this.$store.getters.scope }),
        getDataScopeTableColumn({ vm: this }),
        getNotifyTypeTableColumn(),
      ],
    }
  },
}
</script>
